<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell weui-cell_select weui-cell_select-after" slot="ra_type">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ra_type || "维保类型"}}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.ra_type"
              placeholder="请选择"
            >
              <option>维修</option>
              <option>保养</option>
            </select>
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after" slot="ra_urgency">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ra_urgency || "紧急程度"}}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.ra_urgency"
              placeholder="请选择"
            >
              <option>一般</option>
              <option>紧急</option>
            </select>
          </div>
        </div>
        <div class="weui-cell" slot="ra_device_name">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ra_device_name || "设备名称"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.ra_device_name"
              placeholder="请输入设备名称"
            />
          </div>
        </div>
        <div class="weui-cell" slot="ra_device_place">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ra_device_place || "设备位置"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.ra_device_place"
              placeholder="请输入设备位置"
            />
          </div>
        </div>
        <div class="weui-cell" slot="ra_amount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              form.main.ra_type == "维修" ? "维修金额" : "保养金额"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.ra_amount"
              minvalue="0"
              maxvalue="99999999"
            />
          </div>
        </div>
        <file-field v-model="form.main.ra_attach" slot="ra_attach"/>
      </custom-layout>

      <div class="weui-cells__group textarea-cell">
        <div class="weui-cells__title">
          {{ form.main.ra_type == "维修" ? "故障描述" : "保养描述" }}
        </div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                :placeholder="
                  form.main.ra_type == '维修'
                    ? '请输入故障描述'
                    : '请输入保养描述'
                "
                rows="3"
                v-model="form.main.ra_remark"
                maxlength="300"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{
                  form.main.ra_remark ? form.main.ra_remark.length : 0
                }}</span
                >/300
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    FileField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/repairapply",
      codeField: "ra_code",
      statusField: "ra_statuscode",
      caller: "RepairApply",
      xtype: "oa-repairapply-formpanel",
      form: {
        main: {
          ra_type: "维修",
          ra_urgency: "一般",
          ra_indate: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
          ra_amount: 0,
          ra_device_name: null,
          ra_device_place: null,
          ra_remark: null,
          ra_attach: null,
        },
      },
    };
  },
  methods: {
     getData() {
      var me = this,
        data = me.$route.params.data;
      if (data) {
        me.form.main.ra_device_name = data.name;
        me.form.main.ra_remark = data.describe;
      }
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.ra_device_name) {
        me.$weui.topTips("请填写设备名称", 2000);
      } else if (!main.ra_remark) {
        me.$weui.topTips(
          "请填写" + (main.ra_type == "维修" ? "故障描述" : "保养描述"),
          2000
        );
      } else {
        me.p_save();
      }
    },
  },
  created() {
    this.getData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData();
    });
  },
};
</script>